import React from "react"
import { AppFunctionComponent } from "../../types"
import { BackgroundWrapper } from "../../components/common/sections/section.component"

interface Style {
  text_max_width?: number
  image_max_width?: number
  background?: string
  no_space_below?: boolean
  paddingTopModifier?: number
  paddingBottomModifier?: number
  backgroundCropped?: boolean
}

interface Props {
  customStyle: Style | undefined
  $isUgc?: boolean
}

const SectionBackgroundWrapper: AppFunctionComponent<Props> = ({
  customStyle,
  children,
}) => {
  if (customStyle?.background) {
    return (
      <BackgroundWrapper
        background={customStyle.background}
        no_space_below={customStyle.no_space_below}
        paddingTopModifier={customStyle.paddingTopModifier}
        paddingBottomModifier={customStyle.paddingBottomModifier}
        backgroundCropped={customStyle.backgroundCropped}
      >
        {children}
      </BackgroundWrapper>
    )
  }
  return <section>{children}</section>
}

export default SectionBackgroundWrapper
